/* ==========================================================================
   SSV Fashion Collection - collection filter tweaks

   1. SIZE labels are shortened to the code in brackets:
        "Extra small (XS)"       -> "XS"
        "Four extra large (4XL)" -> "4XL"
      The Size facet is `filter.v.t.shopify.size`, a Shopify standard
      taxonomy filter, so those long names come from Shopify's taxonomy -
      they cannot be renamed in the admin. Values with no bracketed code
      ("M", "L", "XL") are left alone.

      The size label markup is

        <span>Extra small (XS)<span class="product-count">(2)</span></span>

      so the name lives in TEXT NODES alongside a nested count span. Only
      the text nodes are rewritten - replacing the wrapper's textContent
      would destroy the count, and a regex anchored to the end of the
      wrapper's text would match "(2)" rather than "(XS)".

   2. HOW MANY VALUES SHOW BEFORE "+ Show more":
        Size   - all of them, button hidden
        Colour - first 30, the rest behind "+ Show more"

      The theme truncates by putting `show-more-item hidden` on every value
      past its own limit (10), and show-more.js TOGGLES `hidden` on every
      `.show-more-item` in the group. So to promote a value to
      always-visible, both classes must come off - just removing `hidden`
      would make the button hide it again on the next click.

   facets.js replaces the whole filter markup on every filter change, so a
   MutationObserver re-applies this. All work is guarded so repeat passes
   are no-ops and cannot loop.
   ========================================================================== */
(function () {
  'use strict';

  var SIZE_VISIBLE = Infinity; // show every size
  var COLOR_VISIBLE = 30;      // show 30 colours, rest behind Show more

  function labelWrapper(label) {
    for (var i = 0; i < label.children.length; i++) {
      var el = label.children[i];
      if (el.tagName !== 'SPAN') continue;
      if (el.classList.contains('visually-hidden')) continue;
      if (/(^|\s)bg-color-/.test(el.className)) continue;
      return el;
    }
    return null;
  }

  function shortenSizes(root) {
    var labels = root.querySelectorAll('.facets__list-size label.facet-checkbox');

    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.getAttribute('data-ssv-short') === '1') continue;

      var wrap = labelWrapper(label);
      if (!wrap) continue;

      var textNodes = [];
      for (var n = 0; n < wrap.childNodes.length; n++) {
        if (wrap.childNodes[n].nodeType === 3) textNodes.push(wrap.childNodes[n]);
      }
      if (!textNodes.length) continue;

      var name = '';
      for (var t = 0; t < textNodes.length; t++) name += textNodes[t].nodeValue;
      name = name.replace(/\s+/g, ' ').trim();
      if (!name) continue;

      var m = name.match(/\(([^()]+)\)\s*$/);
      var short = m && m[1].trim() ? m[1].trim() : name;

      textNodes[0].nodeValue = short + ' ';
      for (var k = 1; k < textNodes.length; k++) textNodes[k].nodeValue = '';

      label.setAttribute('data-ssv-short', '1');
      if (!label.getAttribute('title')) label.setAttribute('title', name);
    }
  }

  function expandList(listSelector, visibleCount) {
    var lists = document.querySelectorAll(listSelector);

    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      var items = [];
      for (var c = 0; c < ul.children.length; c++) {
        if (ul.children[c].tagName === 'LI') items.push(ul.children[c]);
      }

      for (var j = 0; j < items.length && j < visibleCount; j++) {
        items[j].classList.remove('show-more-item');
        items[j].classList.remove('hidden');
      }

      /* Nothing left to reveal means the button has no job to do. */
      var wrap = ul.closest('.parent-display') || ul.closest('details');
      if (!wrap) continue;
      var button = wrap.querySelector('show-more-button');
      if (!button) continue;
      var remaining = ul.querySelectorAll('.show-more-item').length;
      button.style.display = remaining > 0 ? '' : 'none';
    }
  }

  function apply() {
    try {
      shortenSizes(document);
      expandList('ul.facets__list-size', SIZE_VISIBLE);
      expandList('ul.facets__list-color', COLOR_VISIBLE);
    } catch (e) {
      /* never let a filter tweak break the page */
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function init() {
    apply();
    if (!window.MutationObserver) return;
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();